import { render, staticRenderFns } from "./TheFooterAdd.vue?vue&type=template&id=06f32c68&scoped=true&"
import script from "./TheFooterAdd.vue?vue&type=script&lang=js&"
export * from "./TheFooterAdd.vue?vue&type=script&lang=js&"
import style0 from "./TheFooterAdd.vue?vue&type=style&index=0&id=06f32c68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f32c68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBottomSheet,VBtn,VCol,VSheet,VSpacer,VTextField,VToolbar,VToolbarTitle})
